import { render, staticRenderFns } from "./ImportFeed.vue?vue&type=template&id=b01f8d4e&"
import script from "./ImportFeed.vue?vue&type=script&lang=js&"
export * from "./ImportFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports